export default __webpack_public_path__ + "static/media/avatar.5853dc92.jpg";